import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles({ name: 'Summaries' })((theme) => ({
    root: {
        position: 'sticky',
        top: 120,
        fontSize: 14
    },
    item: {
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        padding: '8px',
        textDecoration: 'none',
        borderRadius: 8,
        transition: 'all 0.2s',
        '@media (hover: hover)': {
            '&:hover': {
                backgroundColor: theme.palette.action.hover
            }
        }
    },
    title: {
        fontSize: 13,
        color: '#8E8E8E',
        lineHeight: '150%',
        letterSpacing: '-0.26px'
    },
    _active: {
        color: '#232323'
    },
    date: {
        fontSize: 12,
        color: '#8E8E8E',
        lineHeight: '16px',
        letterSpacing: '-0.24px'
    }
}));
